/**
 * Checkout de assinatura do Mercado Pago.
 *
 * Assinatura recorrente não passa por carrinho nem pela tela `/pagamento`:
 * o checkout dela é uma página do próprio MP, que coleta o meio de pagamento
 * e faz a cobrança mensal. Ao site cabe só redirecionar para lá — não há
 * endpoint de backend envolvido, ao contrário dos pacotes de horas.
 *
 * A URL é o `init_point` que a API do MP devolve para um plano, e é derivável
 * do `preapproval_plan_id`. Guardamos só o id (em `produtos`), porque é a
 * mesma chave que o webhook PHP usa para resolver o plano.
 */

const CHECKOUT_BASE = "https://www.mercadopago.com.br/subscriptions/checkout";

/**
 * @param {string} preapprovalPlanId id do plano no MP
 * @returns {string|null} URL do checkout, ou null se o id for inválido
 */
export function buildSubscriptionCheckoutUrl(preapprovalPlanId) {
  const id = String(preapprovalPlanId ?? "").trim();

  if (!id) return null;

  return `${CHECKOUT_BASE}?preapproval_plan_id=${encodeURIComponent(id)}`;
}
